<template>
  <div v-click-outside="onClickOutside"
       :style="{ position: 'relative' }"
       @click="onClick"
       @mouseover="onMouseover"
       @mouseout="onMouseout">
    <slot name="trigger" />
    <div v-bind="$attrs"
         v-if="!disablePopover"
         v-on="$listeners"
         :style="style"
         @click.stop>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'
  import { getPseudoClasses } from '@js/vue-style-utils'

  export default {
    name: 'BasePopover',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'switch',
    },
    directives: {
      ClickOutside,
    },
    props: {
      vmodelValue: { type: Boolean },
      disablePopover: { type: Boolean, required: false, default: false },
      byClick: { type: Boolean, required: false, default: false },
      byMouseover: { type: Boolean, required: false, default: false },
      byMouseout: { type: Boolean, required: false, default: false },
      horizontalPosition: { type: String, required: false, default: 'left' },
      toggle: { type: Boolean, required: false, default: false },
      verticalPosition: { type: String, required: false, default: 'bottom' },
    },
    data: function () {
      return {
        show: false,
      };
    },
    created: function () {
      this.show = this.vmodelValue;
    },
    computed: {
      display: function () {
        return this.show ? 'block' : 'none';
      },
      style: function () {
        return {
          zIndex: 1,
          position: 'absolute',
          display: this.display,
          left: this.horizontalPosition === 'left' ? 0 : 'none',
          right: this.horizontalPosition === 'left' ? 'none' : 0,
          top: this.verticalPosition === 'top' ? '-100%' : '100%',
          ...this.$attrs,
        };
      },
    },
    methods: {
      onClick: function () {
        if (this.byClick) {
          this.switchDisplay();
        }
      },
      onMouseover: function () {
        if (this.byMouseover) {
          this.show = true;
        }
      },
      onMouseout: function () {
        if (this.byMouseout) {
          this.show = false;
        }
      },
      onClickOutside: function () {
        this.$emit('click-outside');
        //this.show = false;
      },
      switchDisplay: function () {
        this.show = !this.show;
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.show = newVal;
      },
      toggle: function (newVal, oldVal) {
        this.switchDisplay();
      },
      show: function (newVal, oldVal) {
        this.$emit('popover-updated', newVal);
      },
    },
  };
</script>
